import React from 'react'
import '../about/about.css'
import { motion } from 'framer-motion'

const About = () => {
  return (
    <motion.div className='about'
    initial={{opacity: 0}}
    whileInView={{opacity: 1}}
    viewport={{once: true}} >
        <div className="title">
        <h2>About us</h2>
        <div className="underline"></div>
    </div>
    <div className='intro-about'>
      <div className="about-left">
        <div className="about-name">
          <h1>The story behind <span>Goya</span></h1>
          <h5 className='story'> Located in Barcelona, Goya opened his doors to those who are looking for a fine Japanese cuisine. We offer the best rolls, sashimis and entrees of the city. Our story began in 2009. We were looking for a good Japanese restaurant to eat in Barcelona. We realized that a traditional restaurant was needed in the city, since we had not found one. Goya was born at the end of 2009, seeking to meet the need of all those who wanted to eat quality Japanese food in the heart of Barcelona.</h5>
        </div>
        <div className='sushi-yoga'>
          <img src={require('../../assets/sushiyoga.png')} alt="" />
        </div>
      </div>
      <div className="restaurant">  
        <img src={require('../../assets/restaurant.jpg')} alt="" />
      </div>
      </div>
  </motion.div>
  )
}

export default About